import EventEmitter from 'eventemitter3';
import { clamp,createWorkletModuleUrl } from "../utils";
import {logger} from '../utils/logger.js';

class AudioPlayer extends EventEmitter {

    player = undefined;
    audioContext = undefined;
    gainNode = undefined;
    scriptNode = undefined;
    playing = false;

    atype = 0;
    samplerate = 0;
    channels = 0;
    samplesPerPacket = 0;

    pcmlist = [];

    init = false;

    tag = 'AudioPlayer'

    constructor(player) {

        super();

        this.player = player;

        this.playing = false;
        this.init = false;




        logger.info(this.tag, 'created');

    }

   async setAudioInfo(atype, samplerate, channels, samplesPerPacket) {

        this.clear();

        this.atype = atype;
        this.samplerate = samplerate;
        this.channels = channels;
        this.samplesPerPacket = samplesPerPacket

        this.audioContext = new (window.AudioContext || window.webkitAudioContext)({sampleRate:samplerate});

        this.gainNode = this.audioContext.createGain();

        this.audioEnabled(true);
        // default setting 0
        this.gainNode.gain.value = 0;
        
        let audioNode 
        
        if (this.player.options.audioEngine == 'worklet') {

            audioNode = await this.createWorkletNode()

        } else {

            audioNode = this.createScriptNode()
        }
        


        audioNode.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination);

        this.init = true;
    }


    createScriptNode() {

        let scriptNode = this.audioContext.createScriptProcessor(this.samplesPerPacket, 0, this.channels);

        scriptNode.onaudioprocess = (audioProcessingEvent) => {

         let outputBuffer = audioProcessingEvent.outputBuffer;

          let pcmpacket = this.pcmlist.shift();

            if (!pcmpacket) {

                for (let i = 0; i < this.channels; i++) {

                    let nowBuffering = outputBuffer.getChannelData(i);
                    nowBuffering.fill(0, 0);
                }
                return;
            }

            for (let i = 0; i < this.channels; i++) {
                let b = pcmpacket.datas[i];
                let nowBuffering = outputBuffer.getChannelData(i);
                nowBuffering.set(b);
               
            }
      
        }

       
        this.scriptNode = scriptNode;

        return scriptNode
    }


    async createWorkletNode() {

        function audiWorkletProcessor() {
            class WorkletProcessor extends AudioWorkletProcessor {
                constructor(options) {
                    super();
                    this.samplesPerPacket = options.processorOptions.samplesPerPacket;
                    this.start = false;
                    this.channels = options.outputChannelCount[0];
                    this.pcmlist = [];
                    this.offset = 0;

                    this.port.onmessage = (e) => {
                        // console.log('WorkletProcessor onmessage', e.data);
                        if (e.data.message === "start") {
                            this.start = true;
                        } else if (e.data.message === "stop") {
                            this.start = false;
                            this.pcmlist = [];
                            this.offset = 0;
                        } else if (e.data.message === "data") {
                            this.pcmlist.push(e.data.pcmpacket)
                        } 
                    }
                }

                process(inputs, outputs, parameters) {
                    
                     let output = outputs[0]

                     if (this.pcmlist.length > 0) {

                        for(let i = 0; i < this.channels; i++) {

                            let channelData = output[i];
                            let cur = this.pcmlist[0].datas[i];
                            let b = cur.subarray(this.offset, this.offset + 128)    
                            channelData.set(b)
                         }

                         this.offset += 128;

                         if (this.offset >= this.samplesPerPacket) {

                            this.offset = 0;
                            this.pcmlist.shift();
                         }

                     }

                    return this.start;
                }
            }

            registerProcessor('worklet-processor', WorkletProcessor);
        }

        let workletUrl = createWorkletModuleUrl(audiWorkletProcessor);

        await this.audioContext.audioWorklet.addModule(workletUrl)


        URL.revokeObjectURL(this.workletUrl);

        try {

            this.workletNode = new AudioWorkletNode(this.audioContext, "worklet-processor", {
                processorOptions: {
                    samplesPerPacket:this.samplesPerPacket
                },
                outputChannelCount:[this.channels]
            });
        } catch (e) {
            //  DOMException: Failed to construct 'AudioWorkletNode': AudioWorkletNode cannot be created:
            //  The node name 'worklet-processor' is not defined in AudioWorkletGlobalScope.
            logger.error(this.tag, 'initWorkletScriptNode error', e);
            this.workletNode = null;
            return
        }

        this.workletNode.port.postMessage({
            message: "start",
        });

        this.workletNode.port.onmessage = (e) => {
            // console.log('workletProcessorNode onmessage', e.data);
            logger.info(this.tag, `recv msg from worklet process ${e}`);
        }

        return this.workletNode

    }

    
    isPlaying() {
        return this.playing;
    }

     isMute() {
        return this.gainNode.gain.value === 0 || this.isStateSuspended();
    }

    volume() {
        return this.gainNode.gain.value;
    }


    mute() {

        if (!this.init) {

            return;
        }

        this.setVolumeInner(0);
        this.audioEnabled(false);

        this.pcmlist = [];
    }

    unMute() {
        if (!this.init) {
            return;
        }
        this.setVolumeInner(1);
        this.audioEnabled(true);
    
    }

    setVolumeInner(volume) {
        volume = parseFloat(volume).toFixed(2);
        if (isNaN(volume)) {
            return;
        }
        this.audioEnabled(true);
        volume = clamp(volume, 0, 1);
        this.gainNode.gain.value = volume;
        this.gainNode.gain.setValueAtTime(volume, this.audioContext.currentTime);
    }



    setVolume(num){
        this.setVolumeInner(num);
        this.audioEnabled(true);
    }

    // 是否播放。。。
    audioEnabled(flag) {

        logger.info(this.tag, `audioEnabled flag ${flag} state ${this.audioContext.state}`);

        if (flag) {
            if (this.audioContext.state === 'suspended') {
                // resume
                this.audioContext.resume();
            }
        } else {
            if (this.audioContext.state === 'running') {
                // suspend
                this.audioContext.suspend();
            }
        }
    }

    isStateRunning() {
        return this.audioContext.state === 'running';
    }

    isStateSuspended() {
        return this.audioContext.state === 'suspended';
    }

    pushPcmData(pcmpacket) {

        if (!this.isStateRunning()) {

            return;
        }

        this.pcmlist.push(pcmpacket);
        
    }


    pause() {

        this.playing = false;
    }

    resume() {
        this.playing = true;
    }

    clear() {

        if (this.ticket) {

            clearInterval(this.ticket);
            this.ticket = this.undefined;
        }

        if (this.scriptNode) {

            this.scriptNode.disconnect(this.gainNode);
            this.scriptNode.onaudioprocess = undefined;
            this.scriptNode = undefined;
        }

        if (this.workletNode) {

            this.workletNode.port.postMessage({
                message: "stop"
            });
            this.workletNode = undefined
        }

        if (this.gainNode) {

            this.gainNode.disconnect(this.audioContext.destination);
            this.gainNode = undefined;
        }

        if (this.audioContext) {
            this.audioContext.close();
            this.audioContext = null;
        }

        this.playing = false;
        this.init = false;
        this.pcmlist = [];

        logger.info(this.tag, 'AudioPlayer clear resouce');
    }


    destroy() {

        this.clear();
        this.removeAllListeners();
        logger.info(this.tag, 'AudioPlayer destroy');
    }

}


export default AudioPlayer;